// src/data/compPlanSeeds.js
// All comp plans transcribed from source system screenshots (2026-05-21).
// Used by the one-shot CompPlanSeeder page to populate Firestore.
//
// Role mapping: Agent->Rep, RM->Regional, Director->Director,
//   Manager->Manager, Lead->Lead, Recruiter->Recruiter,
//   Recruiting Assistant->AsstRecruiter

// Expanded Spectrum product list — each line item on the source comp page.
// Replaces the small SPECTRUM_PRODUCTS in compPlans.js for new plans.
export const SPECTRUM_PRODUCTS_FULL = [
  { id: 'gig',                  name: 'Gig' },
  { id: 'gig_2',                name: '2 Gig' },
  { id: 'ultra',                name: 'Ultra' },
  { id: 'spectrum_internet',    name: 'Spectrum Internet' },
  { id: 'premier',              name: 'Premier' },
  { id: 'internet_100',         name: 'Internet 100' },
  { id: 'internet_assist',      name: 'Internet Assist' },
  { id: 'advantage',            name: 'Advantage' },
  { id: 'select_platinum',      name: 'Select Platinum' },
  { id: 'select_plus',          name: 'Select Plus' },
  { id: 'select_signature',     name: 'Select Signature' },
  { id: 'mi_plan_latino',       name: 'Mi Plan Latino' },
  { id: 'choice_15',            name: 'Choice 15' },
  { id: 'stream',               name: 'Stream' },
  { id: 'stream_essentials',    name: 'Stream Essentials' },
  { id: 'stream_latino',        name: 'Stream Latino' },
  { id: 'legacy_limited_basic', name: 'Legacy Limited Basic' },
  { id: 'xumo',                 name: 'XUMO' },
  { id: 'unlimited_voice',      name: 'Unlimited Voice' },
  { id: 'mobile_1',             name: 'Mobile1' },
  { id: 'mobile_2',             name: 'Mobile2' },
  { id: 'uld',                  name: 'ULD' },
  { id: 'uld_2',                name: 'ULD2' },
];

// Helper to make a rate row. Any role omitted defaults to 0.
const r = (rep, rm, recruiter, ra, director, manager, lead) => ({
  Rep: rep || 0,
  Regional: rm || 0,
  Recruiter: recruiter || 0,
  AsstRecruiter: ra || 0,
  Director: director || 0,
  Manager: manager || 0,
  Lead: lead || 0,
});

export const COMP_PLAN_SEEDS = [
  // ─────────────────────────────────────────────────────────────
  // EGGLESTON - DIRECTORS
  // ─────────────────────────────────────────────────────────────
  {
    id: 'eggleston_directors',
    name: 'EGGLESTON - DIRECTORS',
    carrier: 'Spectrum',
    planType: 'Standard',
    sourceLabel: 'EGGLESTON - DIRECTORS',
    rates: {
      gig:                  r(160, 140, 10, 0,  80, 40, 40),
      gig_2:                r(160, 140, 10, 0,  80, 40, 40),
      ultra:                r(130, 145, 10, 0,  60, 40, 30),
      spectrum_internet:    r(130, 145, 10, 0,  60, 40, 30),
      premier:              r(130, 145, 10, 0,  60, 40, 30),
      internet_100:         r(50,  25,  10, 0,  0,  10, 0),
      internet_assist:      r(50,  25,  10, 0,  0,  10, 0),
      advantage:            r(50,  25,  10, 0,  0,  10, 0),
      select_platinum:      r(30,  20,  0,  0,  10, 10, 10),
      select_plus:          r(30,  20,  0,  0,  10, 10, 10),
      select_signature:     r(30,  20,  0,  0,  10, 10, 10),
      mi_plan_latino:       r(30,  20,  0,  0,  10, 10, 10),
      choice_15:            r(20,  10,  0,  0,  10, 0,  0),
      stream:               r(20,  10,  0,  0,  10, 0,  0),
      stream_essentials:    r(20,  10,  0,  0,  10, 0,  0),
      stream_latino:        r(20,  10,  0,  0,  10, 0,  0),
      legacy_limited_basic: r(20,  10,  0,  0,  10, 0,  0),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(40,  15,  5,  0,  20, 10, 10),
      mobile_2:             r(80,  40,  5,  0,  20, 20, 10),
      uld:                  r(10,  40,  0,  0,  10, 0,  0),
      uld_2:                r(10,  40,  0,  0,  10, 0,  0),
    },
  },

  // ─────────────────────────────────────────────────────────────
  // EGGLESTON - DIRECT TEAM
  // ─────────────────────────────────────────────────────────────
  {
    id: 'eggleston_direct_team',
    name: 'EGGLESTON - DIRECT TEAM',
    carrier: 'Spectrum',
    planType: 'Standard',
    sourceLabel: 'EGGLESTON - DIRECT TEAM',
    rates: {
      gig:                  r(160, 220, 10, 0,  0,  40, 40),
      gig_2:                r(160, 220, 10, 0,  0,  40, 40),
      ultra:                r(130, 205, 10, 0,  0,  40, 30),
      spectrum_internet:    r(130, 205, 10, 0,  0,  40, 30),
      premier:              r(130, 205, 10, 0,  0,  40, 30),
      internet_100:         r(50,  35,  10, 0,  0,  10, 0),
      internet_assist:      r(50,  35,  10, 0,  0,  10, 0),
      advantage:            r(50,  35,  10, 0,  0,  10, 0),
      select_platinum:      r(30,  30,  0,  0,  0,  10, 10),
      select_plus:          r(30,  30,  0,  0,  0,  10, 10),
      select_signature:     r(30,  30,  0,  0,  0,  10, 10),
      mi_plan_latino:       r(30,  30,  0,  0,  0,  10, 10),
      choice_15:            r(20,  20,  0,  0,  0,  0,  0),
      stream:               r(20,  20,  0,  0,  0,  0,  0),
      stream_essentials:    r(20,  20,  0,  0,  0,  0,  0),
      stream_latino:        r(20,  20,  0,  0,  0,  0,  0),
      legacy_limited_basic: r(20,  20,  0,  0,  0,  0,  0),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(40,  15,  5,  0,  0,  10, 10),
      mobile_2:             r(80,  60,  5,  0,  0,  20, 10),
      uld:                  r(10,  50,  0,  0,  0,  0,  0),
      uld_2:                r(10,  50,  0,  0,  0,  0,  0),
    },
  },

  // ─────────────────────────────────────────────────────────────
  // EGGLESTON - COKER  (no Agent row)
  // ─────────────────────────────────────────────────────────────
  {
    id: 'eggleston_coker',
    name: 'EGGLESTON - COKER',
    carrier: 'Spectrum',
    planType: 'Standard',
    sourceLabel: 'EGGLESTON - COKER',
    rates: {
      gig:                  r(0, 90,  10, 0, 370, 0, 0),
      gig_2:                r(0, 90,  10, 0, 370, 0, 0),
      ultra:                r(0, 75,  10, 0, 330, 0, 0),
      spectrum_internet:    r(0, 75,  10, 0, 330, 0, 0),
      premier:              r(0, 75,  10, 0, 330, 0, 0),
      internet_100:         r(0, 15,  10, 0, 80,  0, 0),
      internet_assist:      r(0, 15,  10, 0, 80,  0, 0),
      advantage:            r(0, 15,  10, 0, 80,  0, 0),
      select_platinum:      r(0, 20,  0,  0, 60,  0, 0),
      select_plus:          r(0, 20,  0,  0, 60,  0, 0),
      select_signature:     r(0, 20,  0,  0, 60,  0, 0),
      mi_plan_latino:       r(0, 20,  0,  0, 60,  0, 0),
      choice_15:            r(0, 10,  0,  0, 30,  0, 0),
      stream:               r(0, 10,  0,  0, 30,  0, 0),
      stream_essentials:    r(0, 10,  0,  0, 30,  0, 0),
      stream_latino:        r(0, 10,  0,  0, 30,  0, 0),
      legacy_limited_basic: r(0, 10,  0,  0, 30,  0, 0),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(0, 5,   5,  0, 90,  0, 0),
      mobile_2:             r(0, 30,  5,  0, 140, 0, 0),
      uld:                  r(0, 30,  0,  0, 30,  0, 0),
      uld_2:                r(0, 30,  0,  0, 30,  0, 0),
    },
  },

  // ─────────────────────────────────────────────────────────────
  // CORRALES-DIR-LEAD-AGENT
  // ─────────────────────────────────────────────────────────────
  {
    id: 'corrales_dir_lead_agent',
    name: 'CORRALES-DIR-LEAD-AGENT',
    carrier: 'Spectrum',
    planType: 'Standard',
    sourceLabel: 'CORRALES-DIR-LEAD-AGENT',
    rates: {
      gig:                  r(225, 90,  10, 0, 90, 0, 35),
      gig_2:                r(225, 90,  10, 0, 90, 0, 35),
      ultra:                r(190, 75,  10, 0, 80, 0, 35),
      spectrum_internet:    r(190, 75,  10, 0, 80, 0, 35),
      premier:              r(190, 75,  10, 0, 80, 0, 35),
      internet_100:         r(60,  5,   10, 0, 15, 0, 10),
      internet_assist:      r(60,  5,   10, 0, 15, 0, 10),
      advantage:            r(60,  5,   10, 0, 15, 0, 10),
      select_platinum:      r(40,  25,  0,  0, 15, 0, 0),
      select_plus:          r(40,  25,  0,  0, 15, 0, 0),
      select_signature:     r(40,  25,  0,  0, 15, 0, 0),
      mi_plan_latino:       r(40,  25,  0,  0, 15, 0, 0),
      choice_15:            r(20,  15,  0,  0, 5,  0, 0),
      stream:               r(20,  15,  0,  0, 5,  0, 0),
      stream_essentials:    r(20,  15,  0,  0, 5,  0, 0),
      stream_latino:        r(20,  15,  0,  0, 5,  0, 0),
      legacy_limited_basic: r(20,  15,  0,  0, 5,  0, 0),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(50,  10,  5,  0, 15, 0, 10),
      mobile_2:             r(90,  20,  5,  0, 25, 0, 10),
      uld:                  r(20,  15,  0,  0, 10, 0, 5),
      uld_2:                r(20,  15,  0,  0, 10, 0, 5),
    },
  },

  // ─────────────────────────────────────────────────────────────
  // CORRALES-DIR-AGENT 2
  // ─────────────────────────────────────────────────────────────
  {
    id: 'corrales_dir_agent_2',
    name: 'CORRALES-DIR-AGENT 2',
    carrier: 'Spectrum',
    planType: 'Standard',
    sourceLabel: 'CORRALES-DIR-AGENT 2',
    rates: {
      gig:                  r(225, 110, 10, 0, 105, 0, 0),
      gig_2:                r(225, 110, 10, 0, 105, 0, 0),
      ultra:                r(190, 95,  10, 0, 95,  0, 0),
      spectrum_internet:    r(190, 95,  10, 0, 95,  0, 0),
      premier:              r(190, 95,  10, 0, 95,  0, 0),
      internet_100:         r(60,  10,  10, 0, 20,  0, 0),
      internet_assist:      r(60,  10,  10, 0, 20,  0, 0),
      advantage:            r(60,  10,  10, 0, 20,  0, 0),
      select_platinum:      r(40,  25,  0,  0, 15,  0, 0),
      select_plus:          r(40,  25,  0,  0, 15,  0, 0),
      select_signature:     r(40,  25,  0,  0, 15,  0, 0),
      mi_plan_latino:       r(40,  25,  0,  0, 15,  0, 0),
      choice_15:            r(20,  15,  0,  0, 5,   0, 0),
      stream:               r(20,  15,  0,  0, 5,   0, 0),
      stream_essentials:    r(20,  15,  0,  0, 5,   0, 0),
      stream_latino:        r(20,  15,  0,  0, 5,   0, 0),
      legacy_limited_basic: r(20,  15,  0,  0, 5,   0, 0),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(50,  15,  5,  0, 20,  0, 0),
      mobile_2:             r(90,  25,  5,  0, 30,  0, 0),
      uld:                  r(20,  20,  0,  0, 10,  0, 0),
      uld_2:                r(20,  20,  0,  0, 10,  0, 0),
    },
  },

  // ─────────────────────────────────────────────────────────────
  // CORRALES-DIR-AGENT 1
  // ─────────────────────────────────────────────────────────────
  {
    id: 'corrales_dir_agent_1',
    name: 'CORRALES-DIR-AGENT 1',
    carrier: 'Spectrum',
    planType: 'Standard',
    sourceLabel: 'CORRALES-DIR-AGENT 1',
    rates: {
      gig:                  r(250, 95,  10, 0, 95, 0, 0),
      gig_2:                r(250, 95,  10, 0, 95, 0, 0),
      ultra:                r(220, 75,  10, 0, 85, 0, 0),
      spectrum_internet:    r(220, 75,  10, 0, 85, 0, 0),
      premier:              r(220, 75,  10, 0, 85, 0, 0),
      internet_100:         r(70,  5,   10, 0, 15, 0, 0),
      internet_assist:      r(70,  5,   10, 0, 15, 0, 0),
      advantage:            r(70,  15,  0,  0, 15, 0, 0),
      select_platinum:      r(40,  25,  0,  0, 15, 0, 0),
      select_plus:          r(40,  25,  0,  0, 15, 0, 0),
      select_signature:     r(40,  25,  0,  0, 15, 0, 0),
      mi_plan_latino:       r(40,  25,  0,  0, 15, 0, 0),
      choice_15:            r(20,  15,  0,  0, 5,  0, 0),
      stream:               r(20,  15,  0,  0, 5,  0, 0),
      stream_essentials:    r(20,  15,  0,  0, 5,  0, 0),
      stream_latino:        r(20,  15,  0,  0, 5,  0, 0),
      legacy_limited_basic: r(20,  15,  0,  0, 5,  0, 0),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(60,  10,  5,  0, 15, 0, 0),
      mobile_2:             r(90,  25,  5,  0, 30, 0, 0),
      uld:                  r(25,  15,  0,  0, 10, 0, 0),
      uld_2:                r(25,  15,  0,  0, 10, 0, 0),
    },
  },

  // ─────────────────────────────────────────────────────────────
  // CORRALES - WILLEY
  // ─────────────────────────────────────────────────────────────
  {
    id: 'corrales_willey',
    name: 'CORRALES - WILLEY',
    carrier: 'Spectrum',
    planType: 'Standard',
    sourceLabel: 'CORRALES - WILLEY',
    rates: {
      gig:                  r(225, 140, 10, 0, 75, 0, 0),
      gig_2:                r(225, 140, 10, 0, 75, 0, 0),
      ultra:                r(195, 110, 10, 0, 75, 0, 0),
      spectrum_internet:    r(195, 110, 10, 0, 75, 0, 0),
      premier:              r(195, 110, 10, 0, 75, 0, 0),
      internet_100:         r(70,  5,   10, 0, 15, 0, 0),
      internet_assist:      r(70,  5,   10, 0, 15, 0, 0),
      advantage:            r(70,  5,   10, 0, 15, 0, 0),
      select_platinum:      r(40,  40,  0,  0, 0,  0, 0),
      select_plus:          r(40,  40,  0,  0, 0,  0, 0),
      select_signature:     r(40,  40,  0,  0, 0,  0, 0),
      mi_plan_latino:       r(40,  40,  0,  0, 0,  0, 0),
      choice_15:            r(20,  20,  0,  0, 0,  0, 0),
      stream:               r(20,  20,  0,  0, 0,  0, 0),
      stream_essentials:    r(20,  20,  0,  0, 0,  0, 0),
      stream_latino:        r(20,  20,  0,  0, 0,  0, 0),
      legacy_limited_basic: r(20,  20,  0,  0, 0,  0, 0),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(55,  15,  5,  0, 15, 0, 0),
      mobile_2:             r(90,  45,  5,  0, 10, 0, 0),
      uld:                  r(20,  25,  0,  0, 5,  0, 0),
      uld_2:                r(20,  25,  0,  0, 5,  0, 0),
    },
  },

  // ─────────────────────────────────────────────────────────────
  // ANTHONY ISO BASE  (ISO plan — no Agent payout)
  // ─────────────────────────────────────────────────────────────
  {
    id: 'anthony_iso_base',
    name: 'ANTHONY ISO BASE',
    carrier: 'Spectrum',
    planType: 'ISO',
    sourceLabel: 'ANTHONY ISO BASE',
    rates: {
      gig:                  r(0, 70, 10, 0, 350, 0, 0),
      gig_2:                r(0, 70, 10, 0, 350, 0, 0),
      ultra:                r(0, 60, 10, 0, 300, 0, 0),
      spectrum_internet:    r(0, 60, 10, 0, 300, 0, 0),
      premier:              r(0, 60, 10, 0, 300, 0, 0),
      internet_100:         r(0, 20, 0,  0, 70,  0, 0),
      internet_assist:      r(0, 20, 0,  0, 70,  0, 0),
      advantage:            r(0, 20, 0,  0, 70,  0, 0),
      select_platinum:      r(0, 30, 0,  0, 50,  0, 0),
      select_plus:          r(0, 30, 0,  0, 50,  0, 0),
      select_signature:     r(0, 30, 0,  0, 50,  0, 0),
      mi_plan_latino:       r(0, 30, 0,  0, 50,  0, 0),
      choice_15:            r(0, 15, 0,  0, 25,  0, 0),
      stream:               r(0, 15, 0,  0, 25,  0, 0),
      stream_essentials:    r(0, 15, 0,  0, 25,  0, 0),
      stream_latino:        r(0, 15, 0,  0, 25,  0, 0),
      legacy_limited_basic: r(0, 15, 0,  0, 25,  0, 0),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(0, 30, 0,  0, 60,  0, 0),
      mobile_2:             r(0, 40, 0,  0, 120, 0, 0),
      uld:                  r(0, 25, 0,  0, 25,  0, 0),
      uld_2:                r(0, 25, 0,  0, 25,  0, 0),
    },
  },

  // ─────────────────────────────────────────────────────────────
  // ANTHONY ISO 50+  (ISO plan)
  // ─────────────────────────────────────────────────────────────
  {
    id: 'anthony_iso_50_plus',
    name: 'ANTHONY ISO 50+',
    carrier: 'Spectrum',
    planType: 'ISO',
    sourceLabel: 'ANTHONY ISO 50+',
    rates: {
      gig:                  r(0, 100, 10, 0, 360, 0, 0),
      gig_2:                r(0, 100, 10, 0, 360, 0, 0),
      ultra:                r(0, 85,  10, 0, 320, 0, 0),
      spectrum_internet:    r(0, 85,  10, 0, 320, 0, 0),
      premier:              r(0, 85,  10, 0, 320, 0, 0),
      internet_100:         r(0, 25,  0,  0, 80,  0, 0),
      internet_assist:      r(0, 25,  0,  0, 80,  0, 0),
      advantage:            r(0, 25,  0,  0, 80,  0, 0),
      select_platinum:      r(0, 30,  0,  0, 50,  0, 0),
      select_plus:          r(0, 30,  0,  0, 50,  0, 0),
      select_signature:     r(0, 30,  0,  0, 50,  0, 0),
      mi_plan_latino:       r(0, 30,  0,  0, 50,  0, 0),
      choice_15:            r(0, 15,  0,  0, 25,  0, 0),
      stream:               r(0, 15,  0,  0, 25,  0, 0),
      stream_essentials:    r(0, 15,  0,  0, 25,  0, 0),
      stream_latino:        r(0, 15,  0,  0, 25,  0, 0),
      legacy_limited_basic: r(0, 15,  0,  0, 25,  0, 0),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(0, 30,  0,  0, 70,  0, 0),
      mobile_2:             r(0, 40,  0,  0, 135, 0, 0),
      uld:                  r(0, 30,  0,  0, 30,  0, 0),
      uld_2:                r(0, 30,  0,  0, 30,  0, 0),
    },
  },

  // ─────────────────────────────────────────────────────────────
  // ANTHONY TEAM BASE
  // ─────────────────────────────────────────────────────────────
  {
    id: 'anthony_team_base',
    name: 'ANTHONY TEAM BASE',
    carrier: 'Spectrum',
    planType: 'Standard',
    sourceLabel: 'ANTHONY TEAM BASE',
    rates: {
      gig:                  r(170, 70, 10, 0, 90, 50, 40),
      gig_2:                r(170, 70, 10, 0, 90, 50, 40),
      ultra:                r(150, 60, 10, 0, 70, 50, 30),
      spectrum_internet:    r(150, 60, 10, 0, 70, 50, 30),
      premier:              r(150, 60, 10, 0, 70, 50, 30),
      internet_100:         r(45,  20, 0,  0, 10, 10, 5),
      internet_assist:      r(45,  20, 0,  0, 10, 10, 5),
      advantage:            r(45,  20, 0,  0, 10, 10, 5),
      select_platinum:      r(20,  30, 0,  0, 10, 10, 10),
      select_plus:          r(20,  30, 0,  0, 10, 10, 10),
      select_signature:     r(20,  30, 0,  0, 10, 10, 10),
      mi_plan_latino:       r(20,  30, 0,  0, 10, 10, 10),
      choice_15:            r(10,  15, 0,  0, 5,  5,  5),
      stream:               r(10,  15, 0,  0, 5,  5,  5),
      stream_essentials:    r(10,  15, 0,  0, 5,  5,  5),
      stream_latino:        r(10,  15, 0,  0, 5,  5,  5),
      legacy_limited_basic: r(10,  15, 0,  0, 5,  5,  5),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(35,  30, 0,  0, 10, 10, 5),
      mobile_2:             r(80,  40, 0,  0, 20, 10, 5),
      uld:                  r(10,  25, 0,  0, 5,  5,  5),
      uld_2:                r(10,  25, 0,  0, 5,  5,  5),
    },
  },

  // ─────────────────────────────────────────────────────────────
  // ADKINS - FELTON  (no Agent payout, no Recruiter line)
  // ─────────────────────────────────────────────────────────────
  {
    id: 'adkins_felton',
    name: 'ADKINS - FELTON',
    carrier: 'Spectrum',
    planType: 'Standard',
    sourceLabel: 'ADKINS - FELTON',
    rates: {
      gig:                  r(0, 180, 0, 0, 250, 0, 0),
      gig_2:                r(0, 180, 0, 0, 250, 0, 0),
      ultra:                r(0, 150, 0, 0, 220, 0, 0),
      spectrum_internet:    r(0, 150, 0, 0, 220, 0, 0),
      premier:              r(0, 150, 0, 0, 220, 0, 0),
      internet_100:         r(0, 30,  0, 0, 60,  0, 0),
      internet_assist:      r(0, 30,  0, 0, 60,  0, 0),
      advantage:            r(0, 30,  0, 0, 60,  0, 0),
      select_platinum:      r(0, 20,  0, 0, 60,  0, 0),
      select_plus:          r(0, 20,  0, 0, 60,  0, 0),
      select_signature:     r(0, 20,  0, 0, 60,  0, 0),
      mi_plan_latino:       r(0, 20,  0, 0, 60,  0, 0),
      choice_15:            r(0, 10,  0, 0, 30,  0, 0),
      stream:               r(0, 10,  0, 0, 30,  0, 0),
      stream_essentials:    r(0, 10,  0, 0, 30,  0, 0),
      stream_latino:        r(0, 10,  0, 0, 30,  0, 0),
      legacy_limited_basic: r(0, 10,  0, 0, 30,  0, 0),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(0, 40,  0, 0, 50,  0, 0),
      mobile_2:             r(0, 60,  0, 0, 100, 0, 0),
      uld:                  r(0,0,0,0,0,0,0),
      uld_2:                r(0,0,0,0,0,0,0),
    },
  },

  // ─────────────────────────────────────────────────────────────
  // FRUX TEAM  (has Recruiting Assistant column)
  // ─────────────────────────────────────────────────────────────
  {
    id: 'frux_team',
    name: 'FRUX TEAM',
    carrier: 'Spectrum',
    planType: 'Standard',
    sourceLabel: 'FRUX TEAM',
    rates: {
      gig:                  r(0, 95, 10, 5, 360, 0, 0),
      gig_2:                r(0, 95, 10, 5, 360, 0, 0),
      ultra:                r(0, 95, 10, 5, 300, 0, 0),
      spectrum_internet:    r(0, 95, 10, 5, 300, 0, 0),
      premier:              r(0, 95, 10, 5, 300, 0, 0),
      internet_100:         r(0, 30, 0,  0, 70,  0, 0),
      internet_assist:      r(0, 30, 0,  0, 70,  0, 0),
      advantage:            r(0, 30, 0,  0, 70,  0, 0),
      select_platinum:      r(0, 40, 0,  0, 40,  0, 0),
      select_plus:          r(0, 40, 0,  0, 40,  0, 0),
      select_signature:     r(0, 40, 0,  0, 40,  0, 0),
      mi_plan_latino:       r(0, 40, 0,  0, 40,  0, 0),
      choice_15:            r(0, 20, 0,  0, 20,  0, 0),
      stream:               r(0, 20, 0,  0, 20,  0, 0),
      stream_essentials:    r(0, 20, 0,  0, 20,  0, 0),
      stream_latino:        r(0, 20, 0,  0, 20,  0, 0),
      legacy_limited_basic: r(0, 20, 0,  0, 20,  0, 0),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(0, 42.5, 5, 2.5, 50,  0, 0),
      mobile_2:             r(0, 92.5, 5, 2.5, 100, 0, 0),
      uld:                  r(0, 10, 0,  0, 40,  0, 0),
      uld_2:                r(0, 10, 0,  0, 40,  0, 0),
    },
  },

  // ─────────────────────────────────────────────────────────────
  // FASANO TEAM  (RM + Recruiter only)
  // ─────────────────────────────────────────────────────────────
  {
    id: 'fasano_team',
    name: 'FASANO TEAM',
    carrier: 'Spectrum',
    planType: 'Standard',
    sourceLabel: 'FASANO TEAM',
    rates: {
      gig:                  r(0, 440, 10, 0, 0, 0, 0),
      gig_2:                r(0, 440, 10, 0, 0, 0, 0),
      ultra:                r(0, 380, 10, 0, 0, 0, 0),
      spectrum_internet:    r(0, 380, 10, 0, 0, 0, 0),
      premier:              r(0, 380, 10, 0, 0, 0, 0),
      internet_100:         r(0, 90,  10, 0, 0, 0, 0),
      internet_assist:      r(0, 90,  10, 0, 0, 0, 0),
      advantage:            r(0, 90,  10, 0, 0, 0, 0),
      select_platinum:      r(0, 80,  0,  0, 0, 0, 0),
      select_plus:          r(0, 80,  0,  0, 0, 0, 0),
      select_signature:     r(0, 80,  0,  0, 0, 0, 0),
      mi_plan_latino:       r(0, 80,  0,  0, 0, 0, 0),
      choice_15:            r(0, 40,  0,  0, 0, 0, 0),
      stream:               r(0, 40,  0,  0, 0, 0, 0),
      stream_essentials:    r(0, 40,  0,  0, 0, 0, 0),
      stream_latino:        r(0, 40,  0,  0, 0, 0, 0),
      legacy_limited_basic: r(0, 40,  0,  0, 0, 0, 0),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(0, 85,  5,  0, 0, 0, 0),
      mobile_2:             r(0, 145, 5,  0, 0, 0, 0),
      uld:                  r(0, 50,  0,  0, 0, 0, 0),
      uld_2:                r(0, 50,  0,  0, 0, 0, 0),
    },
  },

  // ─────────────────────────────────────────────────────────────
  // EGGLESTON - SENIOR DIRECTORS
  // ─────────────────────────────────────────────────────────────
  {
    id: 'eggleston_senior_directors',
    name: 'EGGLESTON - SENIOR DIRECTORS',
    carrier: 'Spectrum',
    planType: 'Standard',
    sourceLabel: 'EGGLESTON - SENIOR DIRECTORS',
    rates: {
      gig:                  r(160, 100, 10, 0, 120, 40, 40),
      gig_2:                r(160, 100, 10, 0, 120, 40, 40),
      ultra:                r(130, 100, 10, 0, 100, 40, 30),
      spectrum_internet:    r(130, 105, 10, 0, 100, 40, 30),
      premier:              r(130, 105, 10, 0, 100, 40, 30),
      internet_100:         r(50,  15,  10, 0, 20,  10, 0),
      internet_assist:      r(50,  15,  10, 0, 20,  10, 0),
      advantage:            r(50,  15,  10, 0, 20,  10, 0),
      select_platinum:      r(30,  20,  0,  0, 10,  10, 10),
      select_plus:          r(30,  20,  0,  0, 10,  10, 10),
      select_signature:     r(30,  20,  0,  0, 10,  10, 10),
      mi_plan_latino:       r(30,  20,  0,  0, 10,  10, 10),
      choice_15:            r(20,  10,  0,  0, 10,  0,  0),
      stream:               r(20,  10,  0,  0, 10,  0,  0),
      stream_essentials:    r(20,  10,  0,  0, 10,  0,  0),
      stream_latino:        r(20,  10,  0,  0, 10,  0,  0),
      legacy_limited_basic: r(20,  10,  0,  0, 10,  0,  0),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(40,  5,   5,  0, 30,  10, 10),
      mobile_2:             r(80,  30,  5,  0, 30,  20, 10),
      uld:                  r(10,  20,  0,  0, 30,  0,  0),
      uld_2:                r(10,  20,  0,  0, 30,  0,  0),
    },
  },

  // ─────────────────────────────────────────────────────────────
  // EGGLESTON - OURS BASE  (no Agent payout)
  // ─────────────────────────────────────────────────────────────
  {
    id: 'eggleston_ours_base',
    name: 'EGGLESTON - OURS BASE',
    carrier: 'Spectrum',
    planType: 'Standard',
    sourceLabel: 'EGGLESTON - OURS BASE',
    rates: {
      gig:                  r(0, 40, 10, 0, 370, 0, 0),
      gig_2:                r(0, 40, 10, 0, 370, 0, 0),
      ultra:                r(0, 30, 10, 0, 330, 0, 0),
      spectrum_internet:    r(0, 30, 10, 0, 330, 0, 0),
      premier:              r(0, 30, 10, 0, 330, 0, 0),
      internet_100:         r(0, 10, 10, 0, 80,  0, 0),
      internet_assist:      r(0, 10, 10, 0, 80,  0, 0),
      advantage:            r(0, 10, 10, 0, 80,  0, 0),
      select_platinum:      r(0, 10, 0,  0, 70,  0, 0),
      select_plus:          r(0, 10, 0,  0, 70,  0, 0),
      select_signature:     r(0, 10, 0,  0, 70,  0, 0),
      mi_plan_latino:       r(0, 10, 0,  0, 70,  0, 0),
      choice_15:            r(0, 5,  0,  0, 35,  0, 0),
      stream:               r(0, 5,  0,  0, 35,  0, 0),
      stream_essentials:    r(0, 5,  0,  0, 35,  0, 0),
      stream_latino:        r(0, 5,  0,  0, 35,  0, 0),
      legacy_limited_basic: r(0, 5,  0,  0, 35,  0, 0),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(0, 5,  5,  0, 80,  0, 0),
      mobile_2:             r(0, 15, 5,  0, 140, 0, 0),
      uld:                  r(0, 5,  0,  0, 35,  0, 0),
      uld_2:                r(0, 5,  0,  0, 35,  0, 0),
    },
  },

  // ─────────────────────────────────────────────────────────────
  // EGGLESTON - OURS 100+  (no Agent payout)
  // ─────────────────────────────────────────────────────────────
  {
    id: 'eggleston_ours_100_plus',
    name: 'EGGLESTON - OURS 100+',
    carrier: 'Spectrum',
    planType: 'Standard',
    sourceLabel: 'EGGLESTON - OURS 100+',
    rates: {
      gig:                  r(0, 40, 10, 0, 420, 0, 0),
      gig_2:                r(0, 40, 10, 0, 420, 0, 0),
      ultra:                r(0, 30, 10, 0, 370, 0, 0),
      spectrum_internet:    r(0, 30, 10, 0, 370, 0, 0),
      premier:              r(0, 30, 10, 0, 370, 0, 0),
      internet_100:         r(0, 10, 10, 0, 80,  0, 0),
      internet_assist:      r(0, 10, 10, 0, 80,  0, 0),
      advantage:            r(0, 10, 10, 0, 80,  0, 0),
      select_platinum:      r(0, 10, 0,  0, 70,  0, 0),
      select_plus:          r(0, 10, 0,  0, 70,  0, 0),
      select_signature:     r(0, 10, 0,  0, 70,  0, 0),
      mi_plan_latino:       r(0, 10, 0,  0, 70,  0, 0),
      choice_15:            r(0, 5,  0,  0, 35,  0, 0),
      stream:               r(0, 5,  0,  0, 35,  0, 0),
      stream_essentials:    r(0, 5,  0,  0, 35,  0, 0),
      stream_latino:        r(0, 5,  0,  0, 35,  0, 0),
      legacy_limited_basic: r(0, 5,  0,  0, 35,  0, 0),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(0, 5,  5,  0, 90,  0, 0),
      mobile_2:             r(0, 15, 5,  0, 155, 0, 0),
      uld:                  r(0, 10, 0,  0, 45,  0, 0),
      uld_2:                r(0, 10, 0,  0, 45,  0, 0),
    },
  },

  // ─────────────────────────────────────────────────────────────
  // EGGLESTON - MONTERO - MANAGER
  // ─────────────────────────────────────────────────────────────
  {
    id: 'eggleston_montero_manager',
    name: 'EGGLESTON - MONTERO - MANAGER',
    carrier: 'Spectrum',
    planType: 'Standard',
    sourceLabel: 'EGGLESTON - MONTERO - MANAGER',
    rates: {
      gig:                  r(160, 90, 10, 0, 130, 40, 40),
      gig_2:                r(160, 90, 10, 0, 130, 40, 40),
      ultra:                r(130, 75, 10, 0, 130, 40, 30),
      spectrum_internet:    r(130, 75, 10, 0, 130, 40, 30),
      premier:              r(130, 75, 10, 0, 130, 40, 30),
      internet_100:         r(50,  15, 10, 0, 20,  10, 0),
      internet_assist:      r(50,  15, 10, 0, 20,  10, 0),
      advantage:            r(50,  15, 10, 0, 20,  10, 0),
      select_platinum:      r(30,  20, 0,  0, 10,  10, 10),
      select_plus:          r(30,  20, 0,  0, 10,  10, 10),
      select_signature:     r(30,  20, 0,  0, 10,  10, 10),
      mi_plan_latino:       r(30,  20, 0,  0, 10,  10, 10),
      choice_15:            r(20,  10, 0,  0, 10,  0,  0),
      stream:               r(20,  10, 0,  0, 10,  0,  0),
      stream_essentials:    r(20,  10, 0,  0, 10,  0,  0),
      stream_latino:        r(20,  10, 0,  0, 10,  0,  0),
      legacy_limited_basic: r(20,  10, 0,  0, 10,  0,  0),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(40,  5,  5,  0, 30,  10, 10),
      mobile_2:             r(80,  30, 5,  0, 30,  20, 10),
      uld:                  r(10,  20, 0,  0, 30,  0,  0),
      uld_2:                r(10,  20, 0,  0, 30,  0,  0),
    },
  },

  // ─────────────────────────────────────────────────────────────
  // EGGLESTON - MONTERO - IMHOFF  (no Agent payout)
  // ─────────────────────────────────────────────────────────────
  {
    id: 'eggleston_montero_imhoff',
    name: 'EGGLESTON - MONTERO - IMHOFF',
    carrier: 'Spectrum',
    planType: 'Standard',
    sourceLabel: 'EGGLESTON - MONTERO - IMHOFF',
    rates: {
      gig:                  r(0, 85, 10, 0, 75, 300, 0),
      gig_2:                r(0, 85, 10, 0, 75, 300, 0),
      ultra:                r(0, 75, 10, 0, 80, 250, 0),
      spectrum_internet:    r(0, 75, 10, 0, 80, 250, 0),
      premier:              r(0, 75, 10, 0, 80, 250, 0),
      internet_100:         r(0, 15, 10, 0, 20, 60,  0),
      internet_assist:      r(0, 15, 10, 0, 20, 60,  0),
      advantage:            r(0, 15, 10, 0, 20, 60,  0),
      select_platinum:      r(0, 20, 0,  0, 20, 40,  0),
      select_plus:          r(0, 20, 0,  0, 20, 40,  0),
      select_signature:     r(0, 20, 0,  0, 20, 40,  0),
      mi_plan_latino:       r(0, 20, 0,  0, 20, 40,  0),
      choice_15:            r(0, 10, 0,  0, 10, 20,  0),
      stream:               r(0, 10, 0,  0, 10, 20,  0),
      stream_essentials:    r(0, 10, 0,  0, 10, 20,  0),
      stream_latino:        r(0, 10, 0,  0, 10, 20,  0),
      legacy_limited_basic: r(0, 10, 0,  0, 10, 20,  0),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(0, 15, 5,  0, 20, 70,  0),
      mobile_2:             r(0, 25, 5,  0, 35, 110, 0),
      uld:                  r(0, 20, 0,  0, 25, 15,  0),
      uld_2:                r(0, 20, 0,  0, 25, 15,  0),
    },
  },

  // ─────────────────────────────────────────────────────────────
  // EGGLESTON - MONTERO - GEN MANAGER
  // ─────────────────────────────────────────────────────────────
  {
    id: 'eggleston_montero_gen_manager',
    name: 'EGGLESTON - MONTERO - GEN MANAGER',
    carrier: 'Spectrum',
    planType: 'Standard',
    sourceLabel: 'EGGLESTON - MONTERO - GEN MANAGER',
    rates: {
      gig:                  r(160, 85, 10, 0, 125, 50, 40),
      gig_2:                r(160, 85, 10, 0, 125, 50, 40),
      ultra:                r(130, 75, 10, 0, 100, 70, 30),
      spectrum_internet:    r(130, 75, 10, 0, 100, 70, 30),
      premier:              r(130, 75, 10, 0, 100, 70, 30),
      internet_100:         r(50,  15, 10, 0, 20,  10, 0),
      internet_assist:      r(50,  15, 10, 0, 20,  10, 0),
      advantage:            r(50,  15, 10, 0, 20,  10, 0),
      select_platinum:      r(30,  20, 0,  0, 10,  10, 10),
      select_plus:          r(30,  20, 0,  0, 10,  10, 10),
      select_signature:     r(30,  20, 0,  0, 10,  10, 10),
      mi_plan_latino:       r(30,  20, 0,  0, 10,  10, 10),
      choice_15:            r(20,  10, 0,  0, 10,  0,  0),
      stream:               r(20,  10, 0,  0, 10,  0,  0),
      stream_essentials:    r(20,  10, 0,  0, 10,  0,  0),
      stream_latino:        r(20,  10, 0,  0, 10,  0,  0),
      legacy_limited_basic: r(20,  10, 0,  0, 10,  0,  0),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(40,  5,  5,  0, 20,  20, 10),
      mobile_2:             r(80,  30, 5,  0, 30,  20, 10),
      uld:                  r(10,  20, 0,  0, 30,  0,  0),
      uld_2:                r(10,  20, 0,  0, 30,  0,  0),
    },
  },

  // ─────────────────────────────────────────────────────────────
  // EGGLESTON - LENEUS - MONTREVIL
  // ─────────────────────────────────────────────────────────────
  {
    id: 'eggleston_leneus_montrevil',
    name: 'EGGLESTON - LENEUS - MONTREVIL',
    carrier: 'Spectrum',
    planType: 'Standard',
    sourceLabel: 'EGGLESTON - LENEUS - MONTREVIL',
    rates: {
      gig:                  r(160, 100, 50, 10, 70, 40, 40),
      gig_2:                r(160, 100, 50, 10, 70, 40, 40),
      ultra:                r(130, 105, 40, 10, 60, 40, 30),
      spectrum_internet:    r(130, 105, 40, 10, 60, 40, 30),
      premier:              r(130, 105, 40, 10, 60, 40, 30),
      internet_100:         r(50,  15,  10, 10, 10, 10, 0),
      internet_assist:      r(50,  15,  10, 10, 10, 10, 0),
      advantage:            r(50,  15,  10, 10, 10, 10, 0),
      select_platinum:      r(30,  20,  0,  0,  10, 10, 10),
      select_plus:          r(30,  20,  0,  0,  10, 10, 10),
      select_signature:     r(30,  20,  0,  0,  10, 10, 10),
      mi_plan_latino:       r(30,  20,  0,  0,  10, 10, 10),
      choice_15:            r(20,  10,  0,  0,  10, 0,  0),
      stream:               r(20,  10,  0,  0,  10, 0,  0),
      stream_essentials:    r(20,  10,  0,  0,  10, 0,  0),
      stream_latino:        r(20,  10,  0,  0,  10, 0,  0),
      legacy_limited_basic: r(20,  10,  0,  0,  10, 0,  0),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(40,  5,   10, 5,  20, 10, 10),
      mobile_2:             r(80,  30,  10, 5,  20, 20, 10),
      uld:                  r(10,  20,  0,  0,  30, 0,  0),
      uld_2:                r(10,  20,  0,  0,  30, 0,  0),
    },
  },

  // ─────────────────────────────────────────────────────────────
  // EGGLESTON - JEAN CHOISIL - KT
  // ─────────────────────────────────────────────────────────────
  {
    id: 'eggleston_jean_choisil_kt',
    name: 'EGGLESTON - JEAN CHOISIL - KT',
    carrier: 'Spectrum',
    planType: 'Standard',
    sourceLabel: 'EGGLESTON - JEAN CHOISIL - KT',
    rates: {
      gig:                  r(160, 100, 40, 10, 80, 40, 40),
      gig_2:                r(160, 100, 40, 10, 80, 40, 40),
      ultra:                r(130, 105, 40, 10, 60, 40, 30),
      spectrum_internet:    r(130, 105, 40, 10, 60, 40, 30),
      premier:              r(130, 105, 40, 10, 60, 40, 30),
      internet_100:         r(50,  15,  10, 10, 10, 10, 0),
      internet_assist:      r(50,  15,  10, 10, 10, 10, 0),
      advantage:            r(50,  15,  10, 10, 10, 10, 0),
      select_platinum:      r(30,  20,  0,  0,  10, 10, 10),
      select_plus:          r(30,  20,  0,  0,  10, 10, 10),
      select_signature:     r(30,  20,  0,  0,  10, 10, 10),
      mi_plan_latino:       r(30,  20,  0,  0,  10, 10, 10),
      choice_15:            r(20,  10,  0,  0,  10, 0,  0),
      stream:               r(20,  10,  0,  0,  10, 0,  0),
      stream_essentials:    r(20,  10,  0,  0,  10, 0,  0),
      stream_latino:        r(20,  10,  0,  0,  10, 0,  0),
      legacy_limited_basic: r(20,  10,  0,  0,  10, 0,  0),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(40,  5,   10, 5,  20, 10, 10),
      mobile_2:             r(80,  30,  10, 5,  20, 20, 10),
      uld:                  r(10,  20,  0,  0,  10, 0,  0),
      uld_2:                r(10,  20,  0,  0,  10, 0,  0),
    },
  },

  // ─────────────────────────────────────────────────────────────
  // EGGLESTON - GOINS
  // ─────────────────────────────────────────────────────────────
  {
    id: 'eggleston_goins',
    name: 'EGGLESTON - GOINS',
    carrier: 'Spectrum',
    planType: 'Standard',
    sourceLabel: 'EGGLESTON - GOINS',
    rates: {
      gig:                  r(150, 140, 10, 0, 50, 50, 70),
      gig_2:                r(150, 140, 10, 0, 50, 50, 70),
      ultra:                r(120, 125, 10, 0, 80, 50, 30),
      spectrum_internet:    r(120, 125, 10, 0, 80, 50, 30),
      premier:              r(120, 125, 10, 0, 80, 50, 30),
      internet_100:         r(50,  25,  10, 0, 10, 10, 0),
      internet_assist:      r(50,  25,  10, 0, 10, 10, 0),
      advantage:            r(50,  25,  10, 0, 10, 10, 0),
      select_platinum:      r(30,  20,  0,  0, 10, 10, 10),
      select_plus:          r(30,  20,  0,  0, 10, 10, 10),
      select_signature:     r(30,  20,  0,  0, 10, 10, 10),
      mi_plan_latino:       r(30,  20,  0,  0, 10, 10, 10),
      choice_15:            r(20,  10,  0,  0, 10, 0,  0),
      stream:               r(20,  10,  0,  0, 10, 0,  0),
      stream_essentials:    r(20,  10,  0,  0, 10, 0,  0),
      stream_latino:        r(20,  10,  0,  0, 10, 0,  0),
      legacy_limited_basic: r(20,  10,  0,  0, 10, 0,  0),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(25,  15,  5,  0, 30, 25, 0),
      mobile_2:             r(25,  40,  5,  0, 80, 25, 0),
      uld:                  r(10,  30,  0,  0, 20, 0,  0),
      uld_2:                r(10,  30,  0,  0, 20, 0,  0),
    },
  },

  // ─────────────────────────────────────────────────────────────
  // WALLS TEAM BASE  (no Agent payout)
  // ─────────────────────────────────────────────────────────────
  {
    id: 'walls_team_base',
    name: 'WALLS TEAM BASE',
    carrier: 'Spectrum',
    planType: 'Standard',
    sourceLabel: 'WALLS TEAM BASE',
    rates: {
      gig:                  r(0, 25, 10, 0, 15, 380, 0),
      gig_2:                r(0, 25, 10, 0, 15, 380, 0),
      ultra:                r(0, 25, 10, 0, 15, 320, 0),
      spectrum_internet:    r(0, 25, 10, 0, 15, 320, 0),
      premier:              r(0, 25, 10, 0, 15, 320, 0),
      internet_100:         r(0, 10, 0,  0, 10, 70,  0),
      internet_assist:      r(0, 10, 0,  0, 10, 70,  0),
      advantage:            r(0, 10, 0,  0, 10, 70,  0),
      select_platinum:      r(0, 20, 0,  0, 10, 50,  0),
      select_plus:          r(0, 20, 0,  0, 10, 50,  0),
      select_signature:     r(0, 20, 0,  0, 10, 50,  0),
      mi_plan_latino:       r(0, 20, 0,  0, 10, 50,  0),
      choice_15:            r(0, 15, 0,  0, 5,  20,  0),
      stream:               r(0, 15, 0,  0, 5,  20,  0),
      stream_essentials:    r(0, 15, 0,  0, 5,  20,  0),
      stream_latino:        r(0, 15, 0,  0, 5,  20,  0),
      legacy_limited_basic: r(0, 15, 0,  0, 5,  20,  0),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(0, 20, 0,  0, 10, 60,  0),
      mobile_2:             r(0, 30, 0,  0, 10, 120, 0),
      uld:                  r(0, 20, 0,  0, 10, 20,  0),
      uld_2:                r(0, 20, 0,  0, 10, 20,  0),
    },
  },

  // ─────────────────────────────────────────────────────────────
  // WALLS TEAM 50+  (no Agent payout)
  // ─────────────────────────────────────────────────────────────
  {
    id: 'walls_team_50_plus',
    name: 'WALLS TEAM 50+',
    carrier: 'Spectrum',
    planType: 'Standard',
    sourceLabel: 'WALLS TEAM 50+',
    rates: {
      gig:                  r(0, 65, 10, 0, 15, 380, 0),
      gig_2:                r(0, 65, 10, 0, 15, 380, 0),
      ultra:                r(0, 70, 10, 0, 15, 320, 0),
      spectrum_internet:    r(0, 70, 10, 0, 15, 320, 0),
      premier:              r(0, 70, 10, 0, 15, 320, 0),
      internet_100:         r(0, 15, 0,  0, 10, 80,  0),
      internet_assist:      r(0, 15, 0,  0, 10, 80,  0),
      advantage:            r(0, 15, 0,  0, 10, 80,  0),
      select_platinum:      r(0, 30, 0,  0, 10, 40,  0),
      select_plus:          r(0, 30, 0,  0, 10, 40,  0),
      select_signature:     r(0, 30, 0,  0, 10, 40,  0),
      mi_plan_latino:       r(0, 30, 0,  0, 10, 40,  0),
      choice_15:            r(0, 15, 0,  0, 5,  20,  0),
      stream:               r(0, 15, 0,  0, 5,  20,  0),
      stream_essentials:    r(0, 15, 0,  0, 5,  20,  0),
      stream_latino:        r(0, 15, 0,  0, 5,  20,  0),
      legacy_limited_basic: r(0, 15, 0,  0, 5,  20,  0),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(0, 25, 0,  0, 10, 65,  0),
      mobile_2:             r(0, 25, 0,  0, 10, 140, 0),
      uld:                  r(0, 30, 0,  0, 10, 20,  0),
      uld_2:                r(0, 30, 0,  0, 10, 20,  0),
    },
  },

  // ─────────────────────────────────────────────────────────────
  // SYNERGY
  // ─────────────────────────────────────────────────────────────
  {
    id: 'synergy',
    name: 'SYNERGY',
    carrier: 'Spectrum',
    planType: 'Standard',
    sourceLabel: 'SYNERGY',
    rates: {
      gig:                  r(340, 90, 10, 0, 0, 0, 0),
      gig_2:                r(340, 90, 10, 0, 0, 0, 0),
      ultra:                r(290, 80, 10, 0, 0, 0, 0),
      spectrum_internet:    r(290, 80, 10, 0, 0, 0, 0),
      premier:              r(290, 80, 10, 0, 0, 0, 0),
      internet_100:         r(70,  20, 10, 0, 0, 0, 0),
      internet_assist:      r(70,  20, 10, 0, 0, 0, 0),
      advantage:            r(70,  20, 10, 0, 0, 0, 0),
      select_platinum:      r(60,  20, 0,  0, 0, 0, 0),
      select_plus:          r(60,  20, 0,  0, 0, 0, 0),
      select_signature:     r(60,  20, 0,  0, 0, 0, 0),
      mi_plan_latino:       r(60,  20, 0,  0, 0, 0, 0),
      choice_15:            r(20,  10, 0,  0, 0, 0, 0),
      stream:               r(20,  10, 0,  0, 0, 0, 0),
      stream_essentials:    r(20,  10, 0,  0, 0, 0, 0),
      stream_latino:        r(20,  10, 0,  0, 0, 0, 0),
      legacy_limited_basic: r(20,  10, 0,  0, 0, 0, 0),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(70,  15, 5,  0, 0, 0, 0),
      mobile_2:             r(110, 35, 5,  0, 0, 0, 0),
      uld:                  r(30,  20, 0,  0, 0, 0, 0),
      uld_2:                r(30,  20, 0,  0, 0, 0, 0),
    },
  },

  // ─────────────────────────────────────────────────────────────
  // SILL
  // ─────────────────────────────────────────────────────────────
  {
    id: 'sill',
    name: 'SILL',
    carrier: 'Spectrum',
    planType: 'Standard',
    sourceLabel: 'SILL',
    rates: {
      gig:                  r(180, 140, 10, 0, 50, 50, 20),
      gig_2:                r(180, 140, 10, 0, 50, 50, 20),
      ultra:                r(150, 130, 10, 0, 50, 25, 25),
      spectrum_internet:    r(150, 150, 10, 0, 50, 25, 25),
      premier:              r(150, 150, 10, 0, 50, 25, 25),
      internet_100:         r(50,  5,   10, 0, 15, 10, 10),
      internet_assist:      r(50,  5,   10, 0, 15, 10, 10),
      advantage:            r(50,  5,   10, 0, 15, 10, 10),
      select_platinum:      r(35,  15,  10, 0, 10, 5,  5),
      select_plus:          r(35,  15,  10, 0, 10, 5,  5),
      select_signature:     r(35,  15,  10, 0, 10, 5,  5),
      mi_plan_latino:       r(35,  15,  10, 0, 10, 5,  5),
      choice_15:            r(20,  5,   0,  0, 5,  5,  5),
      stream:               r(20,  5,   0,  0, 5,  5,  5),
      stream_essentials:    r(20,  5,   0,  0, 5,  5,  5),
      stream_latino:        r(20,  5,   0,  0, 5,  5,  5),
      legacy_limited_basic: r(20,  5,   0,  0, 5,  5,  5),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(50,  10,  5,  0, 5,  10, 10),
      mobile_2:             r(60,  45,  5,  0, 20, 5,  15),
      uld:                  r(10,  20,  0,  0, 5,  5,  10),
      uld_2:                r(10,  20,  0,  0, 5,  5,  10),
    },
  },

  // ─────────────────────────────────────────────────────────────
  // RODRIGUEZ TEAM BASE
  // ─────────────────────────────────────────────────────────────
  {
    id: 'rodriguez_team_base',
    name: 'RODRIGUEZ TEAM BASE',
    carrier: 'Spectrum',
    planType: 'Standard',
    sourceLabel: 'RODRIGUEZ TEAM BASE',
    rates: {
      gig:                  r(230, 70, 10, 0, 100, 20, 0),
      gig_2:                r(230, 70, 10, 0, 100, 20, 0),
      ultra:                r(165, 60, 10, 0, 115, 20, 0),
      spectrum_internet:    r(165, 60, 10, 0, 115, 20, 0),
      premier:              r(165, 60, 10, 0, 115, 20, 0),
      internet_100:         r(50,  20, 0,  0, 20,  0,  0),
      internet_assist:      r(50,  20, 0,  0, 20,  0,  0),
      advantage:            r(50,  20, 0,  0, 20,  0,  0),
      select_platinum:      r(30,  30, 0,  0, 20,  0,  0),
      select_plus:          r(30,  30, 0,  0, 20,  0,  0),
      select_signature:     r(30,  30, 0,  0, 20,  0,  0),
      mi_plan_latino:       r(30,  30, 0,  0, 20,  0,  0),
      choice_15:            r(25,  15, 0,  0, 0,   0,  0),
      stream:               r(25,  15, 0,  0, 0,   0,  0),
      stream_essentials:    r(25,  15, 0,  0, 0,   0,  0),
      stream_latino:        r(25,  15, 0,  0, 0,   0,  0),
      legacy_limited_basic: r(25,  15, 0,  0, 0,   0,  0),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(40,  25, 5,  0, 20,  0,  0),
      mobile_2:             r(80,  35, 5,  0, 40,  0,  0),
      uld:                  r(10,  25, 0,  0, 15,  0,  0),
      uld_2:                r(10,  25, 0,  0, 15,  0,  0),
    },
  },

  // ─────────────────────────────────────────────────────────────
  // RODRIGUEZ TEAM 50+
  // ─────────────────────────────────────────────────────────────
  {
    id: 'rodriguez_team_50_plus',
    name: 'RODRIGUEZ TEAM 50+',
    carrier: 'Spectrum',
    planType: 'Standard',
    sourceLabel: 'RODRIGUEZ TEAM 50+',
    rates: {
      gig:                  r(230, 100, 10, 0, 110, 20, 0),
      gig_2:                r(230, 100, 10, 0, 110, 20, 0),
      ultra:                r(165, 85,  10, 0, 135, 20, 0),
      spectrum_internet:    r(165, 85,  10, 0, 135, 20, 0),
      premier:              r(165, 85,  10, 0, 135, 20, 0),
      internet_100:         r(50,  25,  0,  0, 30,  0,  0),
      internet_assist:      r(50,  25,  0,  0, 30,  0,  0),
      advantage:            r(50,  25,  0,  0, 30,  0,  0),
      select_platinum:      r(30,  30,  0,  0, 20,  0,  0),
      select_plus:          r(30,  30,  0,  0, 20,  0,  0),
      select_signature:     r(30,  30,  0,  0, 20,  0,  0),
      mi_plan_latino:       r(30,  30,  0,  0, 20,  0,  0),
      choice_15:            r(25,  15,  0,  0, 0,   0,  0),
      stream:               r(25,  15,  0,  0, 0,   0,  0),
      stream_essentials:    r(25,  15,  0,  0, 0,   0,  0),
      stream_latino:        r(25,  15,  0,  0, 0,   0,  0),
      legacy_limited_basic: r(25,  15,  0,  0, 0,   0,  0),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(40,  25,  5,  0, 30,  0,  0),
      mobile_2:             r(80,  35,  5,  0, 55,  0,  0),
      uld:                  r(10,  30,  0,  0, 20,  0,  0),
      uld_2:                r(10,  30,  0,  0, 20,  0,  0),
    },
  },

  // ─────────────────────────────────────────────────────────────
  // ISO 1 BASE  (ISO plan — no Agent payout)
  // ─────────────────────────────────────────────────────────────
  {
    id: 'iso_1_base',
    name: 'ISO 1 BASE',
    carrier: 'Spectrum',
    planType: 'ISO',
    sourceLabel: 'ISO 1 BASE',
    rates: {
      gig:                  r(0, 415, 10, 5, 0, 0, 0),
      gig_2:                r(0, 415, 10, 5, 0, 0, 0),
      ultra:                r(0, 355, 10, 5, 0, 0, 0),
      spectrum_internet:    r(0, 355, 10, 5, 0, 0, 0),
      premier:              r(0, 355, 10, 5, 0, 0, 0),
      internet_100:         r(0, 75,  10, 5, 0, 0, 0),
      internet_assist:      r(0, 75,  10, 5, 0, 0, 0),
      advantage:            r(0, 75,  10, 5, 0, 0, 0),
      select_platinum:      r(0, 80,  0,  0, 0, 0, 0),
      select_plus:          r(0, 80,  0,  0, 0, 0, 0),
      select_signature:     r(0, 80,  0,  0, 0, 0, 0),
      mi_plan_latino:       r(0, 80,  0,  0, 0, 0, 0),
      choice_15:            r(0, 40,  0,  0, 0, 0, 0),
      stream:               r(0, 40,  0,  0, 0, 0, 0),
      stream_essentials:    r(0, 40,  0,  0, 0, 0, 0),
      stream_latino:        r(0, 40,  0,  0, 0, 0, 0),
      legacy_limited_basic: r(0, 40,  0,  0, 0, 0, 0),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(0, 82.5,  5, 2.5, 0, 0, 0),
      mobile_2:             r(0, 152.5, 5, 2.5, 0, 0, 0),
      uld:                  r(0, 50,  0,  0, 0, 0, 0),
      uld_2:                r(0, 50,  0,  0, 0, 0, 0),
    },
  },

  // ─────────────────────────────────────────────────────────────
  // ISO 1 50+  (ISO plan — no Agent payout)
  // ─────────────────────────────────────────────────────────────
  {
    id: 'iso_1_50_plus',
    name: 'ISO 1 50+',
    carrier: 'Spectrum',
    planType: 'ISO',
    sourceLabel: 'ISO 1 50+',
    rates: {
      gig:                  r(0, 455, 10, 5, 0, 0, 0),
      gig_2:                r(0, 455, 10, 5, 0, 0, 0),
      ultra:                r(0, 400, 10, 5, 0, 0, 0),
      spectrum_internet:    r(0, 400, 10, 5, 0, 0, 0),
      premier:              r(0, 400, 10, 5, 0, 0, 0),
      internet_100:         r(0, 90,  10, 5, 0, 0, 0),
      internet_assist:      r(0, 90,  10, 5, 0, 0, 0),
      advantage:            r(0, 90,  10, 5, 0, 0, 0),
      select_platinum:      r(0, 80,  0,  0, 0, 0, 0),
      select_plus:          r(0, 80,  0,  0, 0, 0, 0),
      select_signature:     r(0, 80,  0,  0, 0, 0, 0),
      mi_plan_latino:       r(0, 80,  0,  0, 0, 0, 0),
      choice_15:            r(0, 40,  0,  0, 0, 0, 0),
      stream:               r(0, 40,  0,  0, 0, 0, 0),
      stream_essentials:    r(0, 40,  0,  0, 0, 0, 0),
      stream_latino:        r(0, 40,  0,  0, 0, 0, 0),
      legacy_limited_basic: r(0, 40,  0,  0, 0, 0, 0),
      xumo:                 r(0,0,0,0,0,0,0),
      unlimited_voice:      r(0,0,0,0,0,0,0),
      mobile_1:             r(0, 92.5,  5, 2.5, 0, 0, 0),
      mobile_2:             r(0, 167.5, 2, 2.5, 0, 0, 0),
      uld:                  r(0, 60,  0,  0, 0, 0, 0),
      uld_2:                r(0, 60,  0,  0, 0, 0, 0),
    },
  },
];
